export interface AccountMenuInfo {
  profileUrl?: string;
  helpCenterUrl?: string;
  logoffUrl?: string;
  changePasswordUrl?: string;
}
